import React from "react";
import {
  Button,
  Col,
  Descriptions,
  List,
  Row,
  Space,
  Tooltip,
  Typography,
  Badge
} from "antd";
import { TLegalViewPresentationModel } from "../../presenter/model/LegalViewPresentationModel";
import Link from "../../../core/ui/components/Link";
import { FileWordOutlined } from "@ant-design/icons";

export interface LegalViewListItemProps {
  translate: any;
  item: TLegalViewPresentationModel;
  showLegalViewDetails: any;
}
const LegalViewListItem: React.FC<LegalViewListItemProps> = (
  props: LegalViewListItemProps
) => {
  const { translate, item, showLegalViewDetails } = props;
  return (
    <List.Item style={{ cursor: "pointer" }} className={"card-list-item"}>
      <Row className={"card-list-item-actions-top"}>
        <Col
          xs={24}
          sm={24}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Badge
            count={translate(
              `editors.legal_views.status_values.${item.status}`
            )}
            className={"png-badge"}
          />
        </Col>
      </Row>
      <Link
        block
        type="text"
        onClick={() => showLegalViewDetails(item.id)}
        children={
          <Col>
            <Typography.Paragraph ellipsis={{ rows: 3 }} strong>
              {item.summaryTranslation ?? item.summary}
            </Typography.Paragraph>
          </Col>
        }
      />
      <Row className={"card-list-item-decriptions"}>
        <Col>
          <Descriptions
            size={"small"}
            column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
          >
            <Descriptions.Item
              // style={{ width: "40%" }}
              label={
                <strong>
                  {translate("editors.legal_views.fields.organisation_name")}
                </strong>
              }
            >
              {item.organisationName}
            </Descriptions.Item>
            <Descriptions.Item
              // style={{ width: "40%" }}
              label={
                <strong>
                  {translate("editors.legal_views.fields.legal_view_type")}
                </strong>
              }
            >
              {item.legalViewType?.name}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row className={"card-list-item-actions-bottom"}>
        <Col>
          <Space size={"small"}>
            <Tooltip title="Preuzmite dokument">
              <Button type="link" icon={<FileWordOutlined />} shape="circle">
                Preuzmite dokument
              </Button>
            </Tooltip>
          </Space>
        </Col>
      </Row>
    </List.Item>
  );
};

export default LegalViewListItem;
